export default __webpack_public_path__ + "static/media/Rec_Letter_for_Aaron_Burns.5f6d9091.pdf";